var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chForm != null)?_c('modal-body',{attrs:{"chForm":_vm.chForm,"noHeader":"","noFooter":"","noModal":""}}):_c('div',{staticClass:"msg"},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v("\n\tCarregando Metadata...\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90a3822c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app-components/sForm.vue
// module id = null
// module chunks = 